import VerifyIdentityContainer from './VerifyIdentityContainer';

export default VerifyIdentityContainer;



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/CreateProfile/components/VerifyIdentity/index.js